import { createContext } from 'react'
import { ConnectionStatus } from '@/constants/connectionStatus'

export interface WalletContextType {
  status: ConnectionStatus
  address: string
  isAdmin: boolean
  isCheckingAdmin: boolean
  connectWallet: () => Promise<void>
  disconnectWallet: () => void
  formatAddress: (addr: string) => string
}

export const WalletContext = createContext<WalletContextType | undefined>(
  undefined
)
